import { API_BASE_URL } from "../config";

export interface ContactFormData {
  name: string;
  email: string;
  message: string;
  phone: string;
}

export interface ContactResponse {
  success: boolean;
  message: string;
  id?: number;
}

export async function submitContactForm(
  data: ContactFormData,
): Promise<ContactResponse> {
  const formData = new FormData();
  formData.append("name", data.name);
  formData.append("email", data.email);
  formData.append("phone", data.phone);
  formData.append("message", data.message);

  const response = await fetch(`${API_BASE_URL}/contact.php`, {
    method: "POST",
    body: formData,
  });

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.message || "Failed to send message");
  }

  return result;
}
